import { BriefcaseIcon, Building2Icon, MessagesSquareIcon, ShieldCheckIcon, UsersIcon, LucideIcon } from "lucide-react";

export type PracticeArea = {
  tag: string;
  title: string;
  description: string;
  icon: LucideIcon;
  image: string;
};

export const practiceAreas: PracticeArea[] = [
  {
    tag: "Business",
    title: "Corporate Law",
    description: "Commercial agreements, business structures and strategic advice built around your objectives.",
    icon: BriefcaseIcon,
    image: "https://cdn.magicpatterns.com/patterns/generated-images/f00d2e1a-ce92-4597-81da-13fbc9fc163d.jpg",
  },
  {
    tag: "Property",
    title: "Property & Disputes",
    description: "Clear guidance through transactions, ownership matters and complex disputes.",
    icon: Building2Icon,
    image: "https://cdn.magicpatterns.com/patterns/generated-images/18a13e3d-5a77-46f9-992f-042370026fbc.jpg",
  },
  {
    tag: "Representation",
    title: "Litigation",
    description: "Focused representation and practical strategy when disagreements escalate.",
    icon: MessagesSquareIcon,
    image: "https://cdn.magicpatterns.com/patterns/generated-images/acccc2df-6978-4edb-86a8-f219f81118e4.jpg",
  },
  {
    tag: "Advisory",
    title: "Compliance & Advisory",
    description: "Practical guidance to manage obligations, regulation and legal risk.",
    icon: ShieldCheckIcon,
    image: "https://cdn.magicpatterns.com/patterns/generated-images/afceb3e4-3eb5-4e58-b819-53df777eb954.jpg",
  },
  {
    tag: "People",
    title: "Employment Law",
    description: "Contracts, policies and workplace disputes handled with discretion and care.",
    icon: UsersIcon,
    image: "https://cdn.magicpatterns.com/patterns/generated-images/9a33e81d-ddbc-4130-8c42-e10f5c8ccd30.jpg",
  },
];
